
import { cache } from '@/utils/cacheManager'
import $store from '@/store'
import checkPermission from '@/utils/permission'
import { searchConfig } from '@/api/user'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { MultiCompanyUtil } from '@/class/cargo/model/utils/MultiCompanyUtil'
import { getUserPrivileges } from '@/api/auth'

export class PricingFCLConfigUtil {
  // 实例集合
  static instanceMap = new Map()
  constructor() {
    this._isAdminOrHQ = MultiCompanyUtil.getInstance().isAdminOrHQ2('PriceFcl')
    this._needContractNo = parseInt(cache.config.get('PFNeedContractNo')) === 1
    this._needMarkup = parseInt(cache.config.get('PFNeedContractNo')) === 1
    this._needCheckValidity = parseInt(cache.config.get('PFNeedCheckValidity')) === 1
    this._needCheckApprove = parseInt(cache.config.get('PFNeedCheckApprove')) === 1
    this._markupLocked = this._needMarkup && parseInt(cache.config.get('PFLockMarkup')) === 1
    this._isAgent = parseInt(cache.config.get('PFIsAgent')) === 1
    this._needAddon = parseInt(cache.config.get('PFNeedAddon')) === 1
    this.isApprove = checkPermission(['PFA'])
    this.isInput = checkPermission(['PFI'])
    this._PFValiditySetting = this._needCheckValidity ? JSON.parse(cache.config.get('PFValiditySetting')) : null
    this._isMarkupSettingsLoaded = false
    if (this._needMarkup && this._markupLocked) {
      this.onMarkupSettingLoaded()
    }
  }
  onMarkupSettingLoaded() {
    searchConfig({ officeId: $store.getters.currentOfficeId, configName: 'PFMarkupSetting' }).then((res) => {
      this._isMarkupSettingsLoaded = true
      const results = res.data
      for (const item of results) {
        if (item.hasOwnProperty('overrideable')) { // Config 才有这个字段
          this.markupCfg = item
          this.decodeMarkupSetting()
        } else {
          this.markupCfgDef = item
        }
      }
    })
  }
  decodeMarkupSetting() {
    if (this.markupCfg && this.markupCfg.value) {
      this.markupCfgValue = JSON.parse(this.markupCfg.value)
    }
  }
  static async getInstance() {
    const officeId = $store.getters.currentOfficeId
    let instance = this.instanceMap.get(officeId)
    if (!instance) {
      await cache.load('config')
      instance = new PricingFCLConfigUtil()
      this.instanceMap.set(officeId, instance)
    }
    return instance
  }
  get needContractNo() {
    return this._needContractNo
  }

  set needContractNo(value) {
    this._needContractNo = value
  }

  get needMarkup() {
    return this._needMarkup
  }

  set needMarkup(value) {
    this._needMarkup = value
  }

  get needCheckValidity() {
    return this._needCheckValidity
  }

  set needCheckValidity(value) {
    this._needCheckValidity = value
  }

  get markupLocked() {
    return this._markupLocked
  }

  set markupLocked(value) {
    this._markupLocked = value
  }

  get isAgent() {
    return this._isAgent
  }

  set isAgent(value) {
    this._isAgent = value
  }

  get needAddon() {
    return this._needAddon
  }

  set needAddon(value) {
    this._needAddon = value
  }

  get isAdminOrHQ() {
    return this._isAdminOrHQ
  }

  set isAdminOrHQ(value) {
    this._isAdminOrHQ = value
  }

  get privileges() {
    return this._privileges
  }

  set privileges(value) {
    this._privileges = value
  }

  async getPolPrivileges() {
    const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
    if (this._isAdminOrHQ) {
      return this.toPolSeaPortMap(seaPorts)
    }
    let pts = []
    if (!this._privileges || this._privileges.length === 0) {
      await this.getPrivileges()
    }
    if (this._privileges && this._privileges.length > 0) {
      const polPrivileges = this._privileges.filter(privilege => this.filterAllPOL(privilege))
      if (polPrivileges && polPrivileges.length > 0) {
        for (const pg of polPrivileges) {
          if (pg.category === 'PFLA') {
            return this.toPolSeaPortMap(seaPorts)
          }
          if (pg.category === 'PFL') {
            if (pg.shape) {
              const ports = this.getPortByCode(seaPorts, pg.shape.substr(2))
              pts = pts.concat(ports)
            }
          }
        }
      }
    }
    return this.toPolSeaPortMap(pts)
  }

  async getPrivileges() {
    await getUserPrivileges().then(res => {
      this._privileges = res.data
    })
  }

  toPolSeaPortMap(pts = []) {
    const pgsLMap = {}
    if (!pts || pts.length === 0) {
      return pgsLMap
    }
    for (const pol of pts) {
      const code = pol.code
      if (code) {
        pgsLMap[code] = this.pol2pg(code)
        const code2 = pol.countryCode + pol.code
        if (code2 && code !== code2) {
          pgsLMap[code2] = this.pol2pg(code2)
        }
      }
    }
    return pgsLMap
  }

  filterAllPOL(item) {
    return item.category.substr(0, 3) === 'PFL'
  }

  getPortByCode(seaPorts = [], code) {
    return seaPorts.filter(item => item.code === code)
  }

  pol2pg(code = '') {
    const pg = {}
    pg.category = 'PFL'
    pg.shape = code || ''
    return pg
  }
}
